import IconTemplate from '@components/Icon';
import { rem } from 'polished';
import styled from 'styled-components';
import { IColors } from '../../interfaces/Conference';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div<{ colors: IColors }>`
    padding: ${rem(40)} ${rem(20)} ${rem(15)} ${rem(20)};
    background: ${(props) => props.colors?.colorLightest};
`;

export const Title = styled.span<{ colors: IColors }>`
    padding-bottom: ${rem(30)};
    display: inline-block;
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h4};
    position: relative;
    color: ${(props) => props.colors?.colorTitle};
`;

export const TitleSymbol = styled.span<{ colors: IColors }>`
    position: absolute;
    width: ${rem(40)};
    height: ${rem(5)};
    background: ${(props) => props.colors?.colorLine};
    left: 0;
    bottom: ${rem(15)};
`;

export const Tabs = styled.div`
    display: flex;
    border-bottom: 1px solid ${({ theme }) => theme.colors.secondaryGrey};
    margin-top: ${rem(20)};
    //overflow: scroll;
`;

export const Tab = styled.div<{ colors: IColors }>`
    margin-right: ${rem(30)};
    color: ${(props) => props.colors?.colorLink};
    cursor: pointer;
    //white-space: nowrap;

    &.active {
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        border-bottom: 2px solid ${(props) => props.colors?.colorLink};
        padding-bottom: ${rem(10)};
    }
`;

export const Content = styled.div`
    margin: 0 ${rem(10)};
`;

export const Chapters = styled.div`
    //  display: flex;
    //   flex-direction: column;
    //   flex-wrap: wrap;
    //   justify-content: center;
    width: 100%;

    @media (max-width: ${breakpoints.sm}px) {
        width: 100%;
        padding-left: 0;
    }
`;

export const Chapter = styled.div`
    cursor: pointer;
    display: flex;
    padding-bottom: ${rem(5)};
    align-items: center;
`;

export const ChapterTime = styled.span<{ colors: IColors; isActive?: boolean }>`
    width: ${rem(45)};
    text-align: right;
    font-size: ${rem(14)};
    ${(prop) => (prop.isActive ? `color: ${prop.colors?.colorLink}` : `color: ${prop.colors?.colorVideoLink}`)};
`;

export const ChapterIcon = styled(IconTemplate)<{ colors: IColors; isActive?: boolean }>`
    padding: 0 ${rem(25)} 0 ${rem(10)};

    svg {
        width: ${rem(20)};
        height: ${rem(20)};

        path {
            ${(prop) => (prop.isActive ? `fill: ${prop.colors?.colorLink}` : `fill: ${prop.colors?.colorVideoLink}`)};
        }
    }
`;

export const ChapterTitle = styled.span<{ colors: IColors; isActive?: boolean }>`
    ${(prop) => (prop.isActive ? `color: ${prop.colors?.colorLink}` : `color: ${prop.colors?.colorVideoLink}`)};
`;

export const Author = styled.div`
    margin: ${rem(20)} 0;
    font-size: ${rem(13)};
`;

export const InfoMessage = styled.span`
    color: ${({ theme }) => theme.colors.primary};
`;
